import fetch from 'isomorphic-fetch';
import {commonErrorHandler, commonHeaders} from './fetch.util';
import {fetchCurrentUserDetailRequest} from './user.actions';

export const PAYMENT_RESULT_RESPONSE = 'PAYMENT_RESULT_RESPONSE';

export function paymentResult(paymentResult) {
  return {
    type: PAYMENT_RESULT_RESPONSE,
    paymentResult,
  };
}

export function fetchPayletterResult(clientparam) {
  clientparam = encodeURIComponent(clientparam);
  return dispatch => {
    fetch(`${API_URL}/purchases/payments/payletter/result?clientparam=${clientparam}`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(response => commonErrorHandler(response))
      .then(response => response.json())
      .then(json => dispatch(paymentResult(json)))
      .then(() => dispatch(fetchCurrentUserDetailRequest()))
      .catch(error => {
        dispatch(paymentResult({result: false, errorCode: error.response, errorMessage: error.message}));
      });
  };
}
